import type { DerivedGallery, DerivedPhoto } from "../types.js";

/**
 * The read-track pre-processing pipeline, as the support console walks it.
 *
 * UR-6 — the union read path no longer tiles. A breaker photo is rectified
 * into ONE whole-panel read image (the union of the geometry columns, cropped
 * and resized), and that single image is what the model reads. So the console's
 * diagnostic heart is the **read image** itself, with the geometry/column
 * overlay drawn on it — "what did the model actually see?".
 *
 * The old per-stage debug cards (`oriented`, `geometry`, `snapped`,
 * `expanded`) are gone — the new scan process has no separate geometry pass,
 * so there are no intermediate stage overlays to step through. The rail now
 * carries only the photo tracks; the center pane shows the read image directly.
 */

/** The derived view of a source photo by id, or `null` when not read. */
export function derivedPhotoFor(
  derived: DerivedGallery | null,
  sourcePhotoId: string | null,
): DerivedPhoto | null {
  if (derived === null || sourcePhotoId === null) return null;
  return (
    derived.photos.find((p) => p.sourcePhotoId === sourcePhotoId) ?? null
  );
}

/** The set of source photo ids that were read (the read-track photos). */
export function breakerPhotoIds(
  derived: DerivedGallery | null,
): ReadonlySet<string> {
  return new Set((derived?.photos ?? []).map((p) => p.sourcePhotoId));
}
